export default __webpack_public_path__ + "static/media/sunset-helping-hand.778ead56.jpg";